import { createContext, useContext, useState, useEffect } from 'react'
import { useAjax } from '../../hooks/use-ajax'

export const SignupContext = createContext()

let idCounter = 0

const generateId = () => {
  idCounter = idCounter + 1
  return idCounter
}

export const useSignup = () => {
  const context = useContext(SignupContext)
  if (!context) {
    throw new Error('no signupform context provided')
  }
  return context
}

export const useSignupProvider = ({ course }) => {
  const [ajax, { error, loading, data: registrations }] = useAjax()
  const [view, setView] = useState('billing') // 'billing' | 'attendees' | 'summary'
  const [billing, setBilling] = useState({})
  const [attendees, setAttendees] = useState([])
  const [additional, setAdditional] = useState({
    acceptTerms: false,
    note: undefined,
  })

  // registration is for waiting list if not places are currently available
  const forWaitingList = !course.available

  return {
    course,
    forWaitingList,
    registrations,
    error,
    loading,
    setView,
    view,
    setAdditional,
    billing,
    stepAvailable: (step) => {
      if (step === 'attendees') {
        return !!billing.firstName
      }
      if (step === 'summary') {
        return billing.firstName && attendees.length > 0
      }
      return true
    },
    updateBilling: (billing) => {
      setBilling(billing)
      if (!attendees.length) {
        setAttendees([
          {
            _id: generateId(),
            separateBilling: false,
            ...billing,
          },
        ])
      }
    },
    attendees,
    getAttendee: (id) => attendees.find((a) => a._id === id),
    addAttendee: (attendee) => {
      setAttendees([
        ...attendees,
        {
          _id: generateId(),
          ...attendee,
        },
      ])
    },
    updateAttendee: (id, form) => {
      setAttendees(
        attendees.map((a) =>
          a._id === id
            ? {
                _id: id,
                ...form,
              }
            : a
        )
      )
    },
    removeAttendee: (id) => {
      // removing attende can leave behind only separatly billed attendees
      let newAttendees = attendees.filter((a) => a._id !== id)
      // count attendees that are not separatly billed
      const count = newAttendees.reduce(
        (sum, a) => (a.separateBilling ? sum : sum + 1),
        0
      )
      if (count === 0 && newAttendees.length > 0) {
        // if there is no attendee left, belonging to the main registration,
        // find the first separately billed attendee and toggle the flag
        const att = newAttendees.find((a) => a.separateBilling)
        newAttendees = newAttendees.map((a) =>
          a._id === att._id
            ? {
                ...a,
                separateBilling: false,
              }
            : a
        )
      }
      setAttendees(newAttendees)
    },
    submit: async (token, form) => {
      const data = {
        recaptchaToken: token,
        courseId: course.id,
        acceptTerms: form.acceptTerms,
        billing,
        attendees,
        note: form.note,
      }
      await ajax.post('submit_registration', data)
    },
  }
}
